export const subscriptionPingsConstants = {
    SUBSCRIPTION_PING: 'SUBSCRIPTION_PING',
    SUBSCRIPTION_PING_SUCCESS: 'SUBSCRIPTION_PING_SUCCESS',
    SUBSCRIPTION_PING_FAILURE: 'SUBSCRIPTION_PING_FAILURE',
    SUBSCRIPTION_PING_RESET: 'SUBSCRIPTION_PING_RESET',

    SUBSCRIPTION_PING_REMOVE: 'SUBSCRIPTION_PING_REMOVE',
    SUBSCRIPTION_PING_ADD: 'SUBSCRIPTION_PING_ADD',

    SUBSCRIPTION_PING_LOADING: 'SUBSCRIPTION_PING_LOADING',
    SUBSCRIPTION_PING_LOADED: 'SUBSCRIPTION_PING_LOADED'
}